module.exports = __webpack_public_path__ + "img/heart_17.ab4db659.png";